<app-title>新規登録</app-title>
<mat-vertical-stepper [linear]="true" #stepper>
  <mat-step>
    <ng-template matStepLabel>写真を撮影・選択する</ng-template>
    <app-file-input color="accent" #img>レシートを選択</app-file-input>
    <ng-container *ngIf="img.value">
      <app-file-input *ngFor="let img of additionalImages">追加画像を選択</app-file-input>
    </ng-container>
    <div class="button-container">
      <div style="flex-grow:1"></div>
      <button mat-raised-button (click)="onClickNextButton()" color="primary">次へ</button>
    </div>
  </mat-step>

  <mat-step>
    <ng-template matStepLabel>情報の入力と登録</ng-template>
    <app-account-wizard-form #accountForm [receipt]="receipt">
    </app-account-wizard-form>
    <div class="button-container">
      <button mat-button matStepperPrevious color="primary">前へ</button>
      <div style="flex-grow:1"></div>
      <button mat-raised-button color="primary" [disabled]="accountForm?.formGroup?.invalid"
        (click)="onClickCreateButton()">登録</button>
    </div>
  </mat-step>
  <mat-step>
    <ng-template matStepLabel>完了</ng-template>
    完了しました。
    <div class="button-container">
      <button mat-raised-button (click)="onClickResetButton()" color="primary">続けて登録する</button>
      <div style="flex-grow:1"></div>
      <button mat-raised-button routerLink="/" color="primary">一覧に戻る</button>
    </div>
  </mat-step>
</mat-vertical-stepper>